'use client';

import type { ProductCard as ProductCardType } from '@repo/supergraph/roundup/base/types';
import { useMemo } from 'react';
import { OffersFilterStoreContext } from './context';
import { createOffersFilterStore } from './store';

export function OffersFilterStoreProvider({
  offers,
  slug,
  children,
}: {
  offers: ProductCardType[];
  slug: string;
  children: React.ReactNode;
}) {
  const store = useMemo(() => createOffersFilterStore(offers, slug), [offers, slug]);
  return (
    <OffersFilterStoreContext.Provider value={store}>{children}</OffersFilterStoreContext.Provider>
  );
}
